var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCounterLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.56,
    height: 56.849,
    viewBox: "0 0 30.56 56.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 56.849,
    height: 30.56,
    fill: " #D2D4C2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(30.56) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M54.035,10.872a22.429,22.429,0,0,0-5.017-.026q.749.906,1.518,1.793a74.917,74.917,0,0,0-7.824,4.684A97.536,97.536,0,0,1,33.224,4.59Q31.81,2.331,30.521,0q-1.023.062-2.1.062T26.329,0q-1.29,2.33-2.7,4.59a97.537,97.537,0,0,1-9.487,12.733,74.916,74.916,0,0,0-7.824-4.684q.768-.886,1.518-1.793a22.423,22.423,0,0,0-5.017.026q-.445.5-.9.99L0,13.955l2.48,1.171a71.136,71.136,0,0,1,10.936,6.429l1.227.876,1.037-1.138a101.388,101.388,0,0,0,12-16.186q.376-.626.741-1.257.365.631.74,1.257a101.431,101.431,0,0,0,12,16.186l1.037,1.138,1.228-.876A71.136,71.136,0,0,1,54.37,15.126l2.479-1.171L54.93,11.863q-.451-.491-.9-.99",
    transform: "translate(0 0)",
    fill: " #D2D4C2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M0,3.062c3.654,6.653,5.879,9.683,6.085,13.254.208-3.571,2.432-6.6,6.085-13.254Q10.888,1.585,9.712,0A25.8,25.8,0,0,0,6.085,8.173,25.819,25.819,0,0,0,2.459,0Q1.284,1.583,0,3.062",
    transform: "translate(22.339 14.244)",
    fill: " #D2D4C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterLeftArrow);
export default __webpack_public_path__ + "static/media/counter-left-arrow.c735735e8dd67fca193bb6d4609ec196.svg";
export { ForwardRef as ReactComponent };